import React from 'react'
import { storiesOf } from '@storybook/react'

import {
  Game,
  IGame,
  Match,
  Team,
  LeaderboardEntry,
  Player,
  Money,
  MatchStatus,
  QuizSection,
  QuizQuestion,
  QuizAnswer,
} from 'protos'

import GameCard from 'components/GameCard'
import QuizCard from 'components/GameCard/components/QuizCard'
import { QuizToggleProvider, QuizToggleContext } from 'contexts/QuizToggleContext'

const game: IGame = Game.create({
  gameId: 'g1',
  match: Match.create({
    status: MatchStatus.MS_LIVE,
    awayTeam: Team.create({ name: 'Manchester United' }),
    homeTeam: Team.create({ name: 'Real Madrid' })
  }),
  ownEntry: LeaderboardEntry.create({
    team: [
      Player.create({ name: 'Kex' }),
      Player.create({ name: 'Mex' }),
      Player.create({ name: 'Tex' }),
      Player.create({ name: 'Rex' }),
    ],
  }),
  entryFee: Money.create({ value: 100, currency: 0 }),
  maxPot: Money.create({ value: 500, currency: 0 }),
  activeQuiz: QuizSection.create({
    question: [
      QuizQuestion.create({
        questionId: 'q1',
        title: 'Who win the match?',
        subtitle: 'Pick one answer.',
        answer: [
          QuizAnswer.create({ answerId: 'a1', shortText: 'me', longText: 'me' }),
          QuizAnswer.create({ answerId: 'a2', shortText: 'donno', longText: 'donno' }),
          QuizAnswer.create({ answerId: 'a3', shortText: 'you', longText: 'you' }),
        ],
      }),
      QuizQuestion.create({
        questionId: 'q2',
        title: 'Who will make me a sandwitch?',
        subtitle: 'Pick one answer.',
        answer: [
          QuizAnswer.create({ answerId: 'a1', shortText: 'you will', longText: 'you will' }),
          QuizAnswer.create({ answerId: 'a2', shortText: 'she will', longText: 'she will' }),
          QuizAnswer.create({ answerId: 'a3', shortText: 'he will', longText: 'he will' }),
        ],
      })
    ],
  })
})

const QuizToggler: React.SFC = () => {
  const { closeQuiz, openQuiz, isQuizClosedByUser, isQuizOpenedByUser } = React.useContext(QuizToggleContext)

  if (!!game.activeQuiz && !isQuizClosedByUser(game.gameId!)) {
    const hasUnansweredQuestion = game.activeQuiz.question!.some(
      (question) => !!question.answer && !!question.answer.length && !question.selectedAnswerId
    )

    if (hasUnansweredQuestion || isQuizOpenedByUser(game.gameId!)) {
      return (
        <QuizCard
          onClose={() => { closeQuiz(game.gameId!) }}
          onAnswer={(questionId, answerId) => {
            return new Promise((resolve) => {
              game.activeQuiz!.question!.forEach((question) => {
                if (question.questionId === questionId) {
                  question.selectedAnswerId = answerId
                }
              })

              setTimeout(() => { resolve() }, 1000)
            })
          }}
          gameId={game!.gameId!}
          homeTeam={game!.match!.homeTeam!.name!}
          awayTeam={game!.match!.awayTeam!.name!}
          questions={game.activeQuiz.question!}
        />
      )
    }
  }

  return (
    <GameCard
      game={game}
      displayQuizButton={true}
      onCickDisplayQuizButton={() => { openQuiz(game.gameId!) }}
    />
  )
}

storiesOf('GameCard', module)
  .addDecorator((story) => (
    <>
      <div style={{ padding: 32, backgroundColor: '#EEE' }}>{story()}</div>
      <div style={{ padding: 32, backgroundColor: '#EEE', width: 320, borderTop: '1px solid #AAA' }}>{story()}</div>
    </>
  ))
  .add('quiz toggler', () => (
    <QuizToggleProvider>
      <QuizToggler />
    </QuizToggleProvider>
  ))
